import React from 'react';
import { FaInstagram, FaArrowRight } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/logo.jpg';
import { SITE_NAME, SOCIAL_LINKS } from '../seoConfig';

const Footer = () => {
    const currentYear = new Date().getFullYear();
    const navigate = useNavigate();

    const handleNav = (path) => { navigate(path); window.scrollTo(0, 0); };

    const navLinks = [
        { l: 'Stock', p: '/automoveis' },
        { l: 'Sobre Nós', p: '/sobre' },
        { l: 'Contactos', p: '/contactos' },
        { l: 'Privacidade', p: '/privacidade' },
        { l: 'Termos', p: '/termos' },
    ];

    return (
        <footer className="bg-black border-t border-white/[0.06] relative overflow-hidden">
            <div className="ajp-grain absolute inset-0" />

            <div className="relative z-10 max-w-[1500px] mx-auto px-5 lg:px-12 pt-20 pb-10">
                {/* Giant wordmark */}
                <div className="mb-16 overflow-hidden">
                    <div className="font-display text-[clamp(4rem,15vw,12rem)] text-white/[0.04] leading-none tracking-widest whitespace-nowrap select-none">
                        AUTO JOÃO PIRES
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-16 border-b border-white/[0.06]">
                    <div className="md:col-span-5 space-y-6">
                        <div className="flex items-center gap-4">
                            <div className="w-14 h-14 border border-white/10 flex items-center justify-center p-2">
                                <img src={logo} alt={SITE_NAME} className="w-full h-full object-contain" />
                            </div>
                            <div>
                                <div className="font-display text-2xl text-white tracking-widest">{SITE_NAME}</div>
                                <div className="text-[10px] font-bold uppercase tracking-[0.25em] text-white/30">Semi-Novos & Usados</div>
                            </div>
                        </div>
                        <p className="text-white/35 text-sm leading-relaxed max-w-sm">
                            Stand, mecânica ligeira, manutenção, inspeções, lavagem, polimentos e cerâmica automóvel.
                        </p>
                        <a
                            href={SOCIAL_LINKS.instagram}
                            target="_blank"
                            rel="noreferrer"
                            className="inline-flex items-center gap-2 text-red text-[11px] font-bold uppercase tracking-[0.2em] hover:text-white transition-colors"
                        >
                            <FaInstagram size={14} />
                            @autojoaopirespt
                        </a>
                    </div>

                    <div className="md:col-span-3">
                        <h3 className="text-[10px] font-bold uppercase tracking-[0.3em] text-white/20 mb-6">Navegação</h3>
                        <ul className="space-y-3">
                            {navLinks.map((link) => (
                                <li key={link.p}>
                                    <button
                                        onClick={() => handleNav(link.p)}
                                        className="group flex items-center gap-2 text-white/40 hover:text-red text-sm font-medium transition-colors bg-transparent border-0 cursor-pointer p-0"
                                    >
                                        <FaArrowRight size={8} className="opacity-0 group-hover:opacity-100 -translate-x-1 group-hover:translate-x-0 transition-all text-red" />
                                        {link.l}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <h3 className="text-[10px] font-bold uppercase tracking-[0.3em] text-white/20 mb-6">Serviços</h3>
                        <ul className="space-y-2 text-white/35 text-sm">
                            <li>Compra & Venda de Automóveis</li>
                            <li>Mecânica Ligeira</li>
                            <li>Manutenção & Inspeções</li>
                            <li>Higienização & Lavagem</li>
                            <li>Polimentos & Cerâmica</li>
                        </ul>
                    </div>
                </div>

                <div className="pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
                    <span className="text-white/20 text-[10px] uppercase tracking-[0.2em]">
                        © {currentYear} {SITE_NAME}
                    </span>
                    <a
                        href="https://samworks.online"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-white/15 hover:text-white/40 text-[10px] uppercase tracking-[0.2em] transition-colors"
                    >
                        by samworks
                    </a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
